import { render, staticRenderFns } from "./SettingsPaymentMethodCreate.vue?vue&type=template&id=4bb8cc0e"
import script from "./SettingsPaymentMethodCreate.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentMethodCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports